import {getNotifications} from '../reducers/notification'
import _ from 'lodash';

export const getNotification = (name: string) => (state: any) => {
    let notifications = getNotifications(state);
    if(notifications[name])    
        return notifications[name];
    else
        throw 'Error';
}